export default __webpack_public_path__ + "static/AnglerGel-f1f64a3e8f3e2e796fad8cfb85a98435.png";